import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export default function useEditCustomerForm(returnRequest: ReturnRequestDto) {
  const t = useTranslation();
  const { customer } = returnRequest;

  const formSchema = z.object({
    email: z
      .string()
      .trim()
      .email(t("returnDetail.rightBar.updateCustomer.invalidEmail")),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    phone: z.string().optional(),
  });

  return useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    defaultValues: {
      email: customer.email ?? "",
      firstName: customer.first_name ?? "",
      lastName: customer.last_name ?? "",
      phone: customer.phone ?? "",
    },
  });
}
